import React from 'react';
import PropTypes from 'prop-types';

import './WoWLevelingClassicRankPicker.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class CataclysmLeveling1to85 extends React.PureComponent {
    static describeRank = rank => rank.toString();

    static minValue = 1;
    static maxValue = 85;

    static getDefaultValue = () => [80, 85];

    static marks = {
        1: '1',
        20: '20',
        40: '40',
        60: '60',
        70: '70',
        80: '80',
        85: '85',
    };

    render() {
        const {intl, collapsed, value, onChange} = this.props;

        return (
            <div>
                <div className="range-inputs">
                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.level'})}
                            min={CataclysmLeveling1to85.minValue}
                            max={CataclysmLeveling1to85.maxValue}
                            value={value[0]}
                            onChange={newValue => onChange([
                                newValue,
                                value[1]
                            ])}
                        />
                    </div>

                    <div className="range-inputs__divider"/>

                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.wanted'})}
                            min={CataclysmLeveling1to85.minValue}
                            max={CataclysmLeveling1to85.maxValue}
                            value={value[1]}
                            onChange={newValue => onChange([
                                value[0],
                                newValue
                            ])}
                        />
                    </div>
                </div>

                {!collapsed && (
                    <div className="slider">
                        <VariableStepRange
                            className="rc-slider-wow-leveling-classic"
                            step={1}
                            min={CataclysmLeveling1to85.minValue}
                            max={CataclysmLeveling1to85.maxValue}
                            marks={CataclysmLeveling1to85.marks}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/wowLevelingClassic/CataclysmLeveling1to85.js